var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-input",class:{
    'active': _vm.value,
    'disabled': _vm.disabled
  },on:{"click":_vm.updateValue}},[_c('div',{staticClass:"toggle-value"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bc90d18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/pro4all-ui/sns-components/kit-components/input-templates/boolean/BooleanInput.vue
// module id = null
// module chunks = 